import { render, staticRenderFns } from "./redZone.vue?vue&type=template&id=f701a9dc&scoped=true"
import script from "./redZone.vue?vue&type=script&lang=js"
export * from "./redZone.vue?vue&type=script&lang=js"
import style0 from "./redZone.vue?vue&type=style&index=0&id=f701a9dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f701a9dc",
  null
  
)

export default component.exports